import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableHead,
  Tooltip,
} from "@mui/material";
import {
  OutlinedIconFab,
  StyledTableCellHistory,
  StyledTableContainer,
  StyledTableRowHistory,
} from "../StyledComponents";
import Icon from "../Utils/Icons";
import { getDefaultFieldLayout } from "../config/defaults/fieldLayoutUtils";
import DisplayDate from "../../../components/date/DisplayDate";

const DEFAULT_COLUMN_RENDER = {
  vaccine_name: (row) => row?.vaccine_name,
  dose: (row) => row?.dose || "-",
  date_of_administration: (row) => (
    <DisplayDate value={row?.date_of_administration} />
  ),
};

export const AdultVaccinationTable = ({
  data,
  activeSection,
  handleEditRow = () => {},
  handleDeleteRow = () => {},
  fieldLayout: fieldLayoutProp,
  fieldSetId,
}) => {
  const fieldLayout =
    fieldLayoutProp ||
    (fieldSetId ? getDefaultFieldLayout(fieldSetId) : getDefaultFieldLayout("adultVaccinationRow"));
  const isHistoryObject = data && !Array.isArray(data) && (data.prev || data.new);
  const vaccinations = isHistoryObject
    ? [...(data.prev || []), ...(data.new || [])]
    : data || [];

  if (vaccinations.length === 0) return null;

  const columns = fieldLayout.tableColumns || [];

  return (
    <>
      {vaccinations.length > 0 && (
        <Grid item xs={12} md={8}>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  {columns.map((column) => (
                    <StyledTableCellHistory key={column.key}>
                      {column.label}
                    </StyledTableCellHistory>
                  ))}

                  {activeSection && (
                    <StyledTableCellHistory>Actions</StyledTableCellHistory>
                  )}
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {vaccinations.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    {columns.map((column) => (
                      <StyledTableCellHistory key={column.key}>
                        {(DEFAULT_COLUMN_RENDER[column.key] || ((r) => r?.[column.key]))(
                          row,
                        )}
                      </StyledTableCellHistory>
                    ))}

                    {activeSection && (
                      <StyledTableCellHistory>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <OutlinedIconFab
                            onClick={() => handleEditRow(rowIndex)}
                            sx={{ marginRight: 1 }}
                          >
                            <Icon name="editInTable" size={32} />
                          </OutlinedIconFab>

                          <OutlinedIconFab
                            onClick={() => handleDeleteRow(rowIndex)}
                          >
                            <Icon name="deleteInTable" size={32} />
                          </OutlinedIconFab>
                        </Box>
                      </StyledTableCellHistory>
                    )}
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
